export default class JobAuthPolicies {
  public create = false
  public readFinancial = false
  public update = false
  public updateAdmin = false
}
